import * as focusTrap from 'focus-trap';

export default function hamburgerMenu() {
  const mediaQuery = window.matchMedia('(min-width: 1024px)');
  const menuOpenedClassName = 'menu-opened';
  const hamburger = document.querySelector('.hamburger');
  const menuLinks = document.querySelectorAll('.header-navigation a');
  const logo = document.querySelector('.header__logo');

  if (!hamburger) return;

  const closeEvent = new CustomEvent('menu-closed');
  let isExpanded = false;

  const trap = focusTrap.createFocusTrap('.header');

  function showMenu() {
    if (logo) {
      logo.style.boxShadow = 'none';
    }
    isExpanded = true;
    hamburger.setAttribute('aria-expanded', isExpanded);
    trap.activate();
    document.body.classList.add(menuOpenedClassName);
    document.addEventListener('keydown', keyDownHandler);
    setTimeout(() => {
      document.activeElement.blur();
      if (logo) {
        logo.style.boxShadow = '';
      }
    }, 50);
  }

  function hideMenu() {
    isExpanded = false;
    hamburger.setAttribute('aria-expanded', isExpanded);
    document.body.classList.remove(menuOpenedClassName);
    trap.deactivate();
    document.removeEventListener('keydown', keyDownHandler);

    document.body.dispatchEvent(closeEvent);
  }

  hamburger.addEventListener('click', () => {
    if (isExpanded) {
      hideMenu();
    } else {
      showMenu();
    }
  });

  menuLinks.forEach((link) => {
    link.addEventListener('click', hideMenu);
  });

  function keyDownHandler(e) {
    if (isExpanded && e.key === 'Escape') {
      hideMenu();
    }
  }

  function resizeHandler(e) {
    if (e.matches && isExpanded) {
      hideMenu();
    }
  }

  resizeHandler(mediaQuery);
  mediaQuery.addEventListener('change', resizeHandler);
}
